module.exports = __webpack_public_path__ + "img/zuche.cbdeec53.png";